var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5247 4.57088C16.1097 4.36269 15.6083 4.44379 15.2801 4.77196L13.1691 6.88302L11.0944 2.21098C10.9216 1.82189 10.5358 1.57111 10.11 1.57111C9.6843 1.57111 9.2985 1.82189 9.12574 2.21103L7.05098 6.88307L4.93999 4.77202C4.61181 4.4439 4.11039 4.36274 3.69541 4.57099C3.28059 4.77902 3.04569 5.22954 3.11262 5.68879L4.07544 12.301C4.15251 12.8303 4.60632 13.2229 5.14123 13.2229H15.0789C15.6138 13.2229 16.0676 12.8303 16.1447 12.301L17.1075 5.68874C17.1744 5.22949 16.9395 4.77896 16.5247 4.57088Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0789 14.3539H5.14125C4.5464 14.3539 4.06421 14.8361 4.06421 15.4309C4.06421 16.0258 4.5464 16.508 5.14125 16.508H15.0789C15.6737 16.508 16.1559 16.0258 16.1559 15.4309C16.1559 14.8361 15.6737 14.3539 15.0789 14.3539Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.aa422c40dad88351398ff9ca0a29b235.svg";
export { ForwardRef as ReactComponent };